import { Box, Divider } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import { useDashboardDaysStore } from 'src/models/useDashboardDaysModel';

import DashboardLayout from '../../Layout/DashboardLayout';
import TimeRangeSelector from '../../TimeRangeSelector';
import DashboardCard, {
  DashboardCardDescription,
} from '@Dashboard/Layout/DashboardCard';
import SpamGraymailSenderChart from './chart';
import SpamGraymailSenderTable from './table';

const SpamGraymailSender = (props: { insightsData: any }) => {
  const { t } = useTranslation();
  const daysModel = useDashboardDaysStore();

  return (
    <DashboardLayout
      title={t('riskUser.sender.spammer')}
      barColor="#CE933A"
      titleBar={
        <TimeRangeSelector widgetId="RiskUserTopSpamAndGraymailSender" />
      }
    >
      <DashboardCard height="100%" width="100%" column={2}>
        <Box>
          <DashboardCardDescription>
            {t('riskUser.sender.spammerDesc')}
          </DashboardCardDescription>
          <SpamGraymailSenderChart
            insightsData={props?.insightsData || {}}
            day={daysModel.days['RiskUserTopSpamAndGraymailSender']}
          />
          <Divider orientation="horizontal" position="relative" mb="24px" />
          <SpamGraymailSenderTable
            insightsData={props?.insightsData || {}}
            day={daysModel.days['RiskUserTopSpamAndGraymailSender']}
          />
        </Box>
      </DashboardCard>
    </DashboardLayout>
  );
};

export default SpamGraymailSender;
